// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-manager-pin {
  width: 87% !important;
  border: 1px solid lightgray !important;
  border-radius: 7px !important;
  padding: 8px;
  margin-top: .5rem !important;
}
.manager-auth-button {
  background-color: #0562FB !important;
  color: white !important;
  border-radius: 7px !important;
  padding: 5px 15px 5px 15px !important;
}

.manager-auth-button-disable{
  color: white !important;
  border-radius: 7px !important;
  background-color: rgb(181, 208, 250) !important;
  padding: 5px 15px 5px 15px !important;

}

/* span {
    background-color: #eaeaea;
    padding: 0.5rem;
  }
   */
.pass-icon {
  position: relative;
  top: 0.5rem;
  margin-left: 0.5rem;
  cursor: pointer;
}

.newManagerAuthContainer {
  width: 100%;
  padding: 0px 64px;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPage/components/ManagerAuth/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,6BAA6B;EAC7B,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,+CAA+C;EAC/C,qCAAqC;;AAEvC;;AAEA;;;;IAII;AACJ;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".auth-manager-pin {\n  width: 87% !important;\n  border: 1px solid lightgray !important;\n  border-radius: 7px !important;\n  padding: 8px;\n  margin-top: .5rem !important;\n}\n.manager-auth-button {\n  background-color: #0562FB !important;\n  color: white !important;\n  border-radius: 7px !important;\n  padding: 5px 15px 5px 15px !important;\n}\n\n.manager-auth-button-disable{\n  color: white !important;\n  border-radius: 7px !important;\n  background-color: rgb(181, 208, 250) !important;\n  padding: 5px 15px 5px 15px !important;\n\n}\n\n/* span {\n    background-color: #eaeaea;\n    padding: 0.5rem;\n  }\n   */\n.pass-icon {\n  position: relative;\n  top: 0.5rem;\n  margin-left: 0.5rem;\n  cursor: pointer;\n}\n\n.newManagerAuthContainer {\n  width: 100%;\n  padding: 0px 64px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
